module.exports = __webpack_public_path__ + "static/inddubio-26f9f4c5911ab54f0c90b54db68af1d4.png";